import { render, staticRenderFns } from "./AppUpdateTable.vue?vue&type=template&id=45a119a0"
import script from "./AppUpdateTable.vue?vue&type=script&lang=js"
export * from "./AppUpdateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports